module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('img', {
    staticClass: "silhouette",
    attrs: {
      "src": "/static/img/salutance/silhouette.png"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-text', [_c('h1', [_vm._v("IMC et perte de poids après chirurgie")]), _vm._v(" "), _c('h3', [_vm._v("Remplissez le formulaire suivant")]), _vm._v(" "), _c('v-form', {
    ref: "form1",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    ref: "weight",
    attrs: {
      "label": "Poids actuel (kg)",
      "rules": _vm.weightRules,
      "suffix": "kg",
      "required": ""
    },
    model: {
      value: (_vm.weight),
      callback: function($$v) {
        _vm.weight = $$v
      },
      expression: "weight"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "weightBefore",
    attrs: {
      "label": "Poids avant la chirurgie (kg)",
      "rules": _vm.weightRules,
      "suffix": "kg",
      "required": ""
    },
    model: {
      value: (_vm.weightBefore),
      callback: function($$v) {
        _vm.weightBefore = $$v
      },
      expression: "weightBefore"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "height",
    attrs: {
      "label": "Taille (cm)",
      "rules": _vm.heightRules,
      "suffix": "cm",
      "required": ""
    },
    model: {
      value: (_vm.height),
      callback: function($$v) {
        _vm.height = $$v
      },
      expression: "height"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [(_vm.valid) ? _c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('h1', [_vm._v("Résultat")])]), _vm._v(" "), _c('v-card-text', [_c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Perte d'excés de poids (%)")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.excessWeightloss))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("IMC actuel")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.bmi))])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ba440b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tools/IMCWeightLossCalc.vue
// module id = 1204
// module chunks = 1